// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"do","pgSpeechBox":"do","speech-list-box":"dp","speechListBox":"dp"};